import React from 'react';
import ChessboardWrapper from '../ChessBoardWrapper';
import PgnViewer from '../PgnViewer';
import NotesInput from '../NotesInput/NotesInput';
import RepertoireList from '../RepertoireList';
import Controls from '../Controls';
import styled from 'styled-components';

function Body() {
  return (
    <MainContainer>
      <ContentArea>
        <BoardArea>
          <ChessboardWrapper />
          <Controls />
        </BoardArea>
        <ViewerArea>
          <NotesInput />
          <PgnViewer />
        </ViewerArea>
      </ContentArea>
      <BottomPanel>
        <RepertoireList />
      </BottomPanel>
    </MainContainer>
  );
}

export default Body;

const MainContainer = styled.main`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-grow: 1;
  min-height: 0;
`;

const ContentArea = styled.div`
  flex: 1;
  display: flex;
  padding: 24px;
  gap: 20px;
  align-items: stretch;
  border-radius: 32px;
  background: rgba(255, 248, 239, 0.62);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  overflow: visible;

  @media (max-width: 1120px) {
    flex-direction: column;
  }
`;

const BoardArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1.6;
  min-width: 0;
  padding: 8px;
`;

const ViewerArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  flex: 0.8;
  min-width: 0;
  min-height: 0;
`;

const BottomPanel = styled.aside`
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-md);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 32vh;
`;
